<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
<is-wait-message [loadComplete]="isLoadComplete" [useBolt]="false"></is-wait-message>
<div class="page-indicator">
    <div class="claims-track-page-title-wrap claims-track-page-title--overview">
        Policy Claims List
        <small class="claims-track-company" style="text-transform:uppercase;">{{package?.policyAccount?.namedInsuredName}}</small>
        <small class="claims-track-number">Policy Number:
            <em>{{policyNumber}}</em>
        </small>
    </div>
</div>
<header style="background:#333;padding:10px 20px;font-size:1.4em;color:#fff;text-transform:uppercase;">{{policyType}}
</header>
<div class="content-container-light-blue bolt-space-bottom-sm">
    <main class="content-container-light-blue__inner" role="main">
        <!-- Has claims section  -->
        <ng-container *ngIf="hasClaims">
            <article class="claims-overview-content flex-tile-container">
                <div class="claims-track-claim-content__text-box dark-gray-text flex-tile">
                    <div>
                        <em>Start a
                            <span style="text-transform: lowercase">{{policyInfoService.getDisplayName(policy)}}</span>
                            claim</em>
                        <br>
                        <p>Filing your claim only takes a few minutes.</p>
                    </div>
                    <div>
                        <button id="startClaim" class="button preferred" (click)="startClaim()">Start a claim</button>
                    </div>
                </div>
                <div class="claims-track-claim-content__text-box flex-tile">
                    <is-search-claim></is-search-claim>
                </div>
            </article>

            <div class="claims-track-claim-content__text-box  dark-gray-text" *ngIf="isAuto">
                <div class="mat-icon-container">
                    <mat-icon svgIcon="glass-damage"></mat-icon>
                </div>
                <div class="flexing">
                    <div class="intro-p">
                        <em>Report glass damage</em>
                        <br>
                        <p>With Nationwide’s On Your Side® Glass Service program, repairs can be completed at your home,
                            office or a
                            repair
                            facility, usually within 24 hours through our partner Safelite AutoGlass®.</p>
                        <p>When filing your glass claim, you can use Safelite or a provider of your choice.</p>
                    </div>
                    <div class="intro-p-button">
                        <button id="glassClaim" (click)="fileAGlassClaim()" class="button preferred">Start a glass
                            claim</button>
                    </div>
                </div>
            </div>
            <div class="claims-track-claim-content__text-box dark-gray-text" *ngIf="isAuto">
                <div class="mat-icon-container">
                    <mat-icon svgIcon="roadside-assistance"></mat-icon>
                </div>
                <div class="flexing">
                    <em>Roadside Assistance</em>
                    <br>Get on-demand help for a flat tire, jump or tow if you've signed up for Roadside Assistance.
                    Call
                    1-800-421-3535
                    anytime.
                </div>
            </div>

            <h2 style="margin-bottom:5px; font-weight:bold; font-size:1.15em; padding-top:15px" id="claimsHeading">
                CLAIMS</h2>
            <article class="claims-overview-content">
                <div class="claims-track-claim-content__text-box">
                    <em>Recently submitted claims may take 24-48 hours to display here.</em>
                    <br>
                    <p>Closed claims with no activity for 12 months cannot be viewed online.</p>
                    <div class="media alert alert-info" *ngIf="!hasOpenClaims && !closedClaimsFilter">
                        <div class="media-left">
                            <div class="nw-icon-info"></div>
                        </div>
                        <div class="media-body">
                            <strong>There are no open claims for this policy.</strong> Check the box to show available
                            closed claims.
                        </div>
                    </div>

                    <input type="checkbox" #showClosedClaims id="showClosedClaims" style="margin-right:10px;margin-bottom:20px" [checked]="closedClaimsFilter"
                        (change)="onClosedClaimFilterChanged(showClosedClaims.checked)">Show available closed claims
                    <ng-container *ngIf="showClaims()">
                        <ng-container *ngFor="let claim of claimsList ; let i=index; ">
                            <div *ngIf="i<(displayOffset+displayLimit) && (i>=displayOffset) && claimsDataService.lossCauseTypesLoaded">
                                <a id="claim_{{claim.claimNumber}}" class="claims-track-claim-content__link-box link-arrow-orange dark-gray-text" style="margin-bottom:10px;padding-bottom:0"
                                    (click)="navigateToClaimOverview(claim.claimNumber, claim.premisisID)" *ngIf="claim.lossCause != 'lockout' && claim.lossCause != 'glassbreakage'">
                                    <ng-container *ngIf="claim.incidentOnly">
                                        <em>{{claimsDataService.getLossCause(claim.lossCause)}}
                                            <span class="claim-number">({{claim.claimNumber}})</span> -
                                            <span style="text-transform: capitalize">{{claim.claimState}}</span>
                                        </em> (Record Only)
                                        <br>
                                    </ng-container>
                                    <ng-container *ngIf="!claim.incidentOnly">
                                        <em>{{claimsDataService.getLossCause(claim.lossCause)}}
                                            <span class="claim-number">({{claim.claimNumber}})</span> -
                                            <span style="text-transform: capitalize">{{claim.claimState}}</span>
                                        </em>
                                        <br>
                                    </ng-container>
                                    <p>Incident date: {{claim.lossDate| date:'MM/dd/yyyy'}}
                                        <ng-container *ngIf="claim.lossLocation.addressLine1">
                                            <br>{{claim.lossLocation.addressLine1}}
                                        </ng-container>
                                        <br>{{claimsDataService.formatLossLocationDisplay(claim.lossLocation)}}
                                    </p>
                                </a>
                                <div id="claim_{{claim.claimNumber}}" *ngIf="claim.lossCause == 'lockout' || claim.lossCause == 'glassbreakage'"
                                    class="claims-track-claim-content__text-box dark-gray-text">
                                    <ng-container *ngIf="claim.incidentOnly">
                                        <em>{{claimsDataService.getLossCause(claim.lossCause)}}
                                            <span class="claim-number">({{claim.claimNumber}})</span> -
                                            <span style="text-transform: capitalize">{{claim.claimState}}</span>
                                        </em> (Record Only)
                                        <br>
                                    </ng-container>
                                    <ng-container *ngIf="!claim.incidentOnly">
                                        <em>{{claimsDataService.getLossCause(claim.lossCause)}}
                                            <span class="claim-number">({{claim.claimNumber}})</span> -
                                            <span style="text-transform: capitalize">{{claim.claimState}}</span>
                                        </em>
                                        <br>
                                    </ng-container>
                                    <p>Incident date: {{claim.lossDate| date:'MM/dd/yyyy'}}
                                        <ng-container *ngIf="claim.lossLocation.addressLine1">
                                            <br>{{claim.lossLocation.addressLine1}}
                                        </ng-container>
                                        <br>{{claimsDataService.formatLossLocationDisplay(claim.lossLocation)}}
                                    </p>
                                </div>
                            </div>
                        </ng-container>

                    </ng-container>
                </div>
            </article>
            <is-pagination *ngIf="showClaims() && totalClaims > displayLimit" [offset]="displayOffset" [limit]="displayLimit" [size]="totalClaims" (pageChange)="onPageChange($event)"></is-pagination>
        </ng-container>
        <!-- Has NO claims section  -->
        <ng-container *ngIf="!hasClaims">
            <h2 style="margin-bottom:5px;font-weight:bold;font-size:1.15em">REPORT A CLAIM</h2>
            <article class="claims-overview-content">
                <div class="claims-track-claim-content__text-box dark-gray-text">
                    <div class="mat-icon-container">
                        <mat-icon [svgIcon]="policyInfoService.getDisplayName(policy)"></mat-icon>
                    </div>
                    <div class="flexing">
                        <div class="intro-p">
                            <em>Start a
                                <span style="text-transform: lowercase">{{policyInfoService.getDisplayName(policy)}}</span>
                                claim</em>
                            <br>
                            <p>Filing your claim only takes a few minutes.</p>
                        </div>
                        <div class="intro-p-button">
                            <button id="startClaim" class="button preferred" (click)="startClaim()">Start a
                                claim
                            </button>
                        </div>
                    </div>
                </div>
            </article>
            <div class="claims-track-claim-content__text-box dark-gray-text" *ngIf="isAuto">
                <div class="mat-icon-container">
                    <mat-icon svgIcon="glass-damage"></mat-icon>
                </div>
                <div class="flexing">
                    <div class="intro-p">
                        <em>Report glass damage</em>
                        <p>Repairs can be completed usually within 24 hours through our partner Safelite AutoGlass®.</p>
                    </div>
                    <div class="intro-p-button">
                        <button id="glassClaim" (click)="fileAGlassClaim()" class="button preferred">Start a glass
                            claim</button>
                    </div>
                </div>
            </div>
            <div class="claims-track-claim-content__text-box dark-gray-text" *ngIf="isAuto">
                <div class="mat-icon-container">
                    <mat-icon svgIcon="roadside-assistance"></mat-icon>
                </div>
                <div class="flexing">
                    <em>Roadside Assistance</em>
                    <br>Get on-demand help for a flat tire, jump or tow if you've signed up for Roadside Assistance. Call
                    1-800-421-3535
                    anytime.
                </div>
            </div>

            <h2 style="margin-bottom:5px; font-weight:bold; font-size:1.15em; padding-top:15px">CLAIMS</h2>
            <article class="claims-overview-content">
                <div class="claims-track-claim-content__text-box dark-gray-text">
                    <div class="flexing">
                        <div>
                            <p>There are no recent claims available to view for this policy. Closed claims with no
                                activity for 12
                                months
                                cannot be viewed online.</p>
                        </div>
                    </div>
                </div>
            </article>
        </ng-container>
    </main>
</div>

<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
